module.exports = __webpack_public_path__ + "img/el-ic-bankcard.71aaae93.svg";